import {AnimatedText, Text} from '#component/base';
import {Transition} from '#component/util';
import {useViewportSize} from '#hook';

import {StepProps} from '../../StorySteps.types';

import * as css from './Step4_0.css';

export const Step4_0 = ({onNext, show}: StepProps) => {
  const handleSkipStep = () => {
    onNext?.();
    onNext?.();
  };

  const {isDesktop} = useViewportSize();

  return (
    <Transition className={css.stepContainer} show={show}>
      {/* Mobile layout - vertical stack */}
      {!isDesktop && (
        <div>
          <div className={css.contentWrapper}>
            <AnimatedText className={css.nextText} textAlign="left">
              NEXT
            </AnimatedText>
            <AnimatedText className={css.discoverText} color="white" textAlign="left">
              How do your results stack up?
            </AnimatedText>
            <div className={css.middleWrapper}>
              <Transition.Child className={css.graphContainer}>
                <Transition.Child className={css.graph}></Transition.Child>
              </Transition.Child>
              <AnimatedText className={css.explanationText} color="white" textAlign="left">
                Epigenetic age can differ between sexes and chronological age groups. Comparing
                yourself to others like you can help contextualize your results.
              </AnimatedText>
            </div>
          </div>
          <Transition.Child className={css.skipTextContainer}>
            <Text
              className={css.skipText}
              color="white"
              variant="bodyLarge"
              onClick={handleSkipStep}>
              Skip this step
            </Text>
          </Transition.Child>
        </div>
      )}

      {/* Desktop layout - two columns */}
      {isDesktop && (
        <div>
          <div className={css.leftWrapper}>
            <AnimatedText className={css.nextText} textAlign="left">
              NEXT
            </AnimatedText>
            <AnimatedText className={css.discoverText} color="white" textAlign="left">
              How do your results stack up?
            </AnimatedText>

            <AnimatedText className={css.explanationText} color="white" textAlign="left">
              Epigenetic age can differ between sexes and chronological age groups. Comparing
              yourself to others like you can help contextualize your results.
            </AnimatedText>

            <Transition.Child className={css.skipTextContainer}>
              <Text
                className={css.skipText}
                color="white"
                variant="bodyLarge"
                onClick={handleSkipStep}>
                Skip this step
              </Text>
            </Transition.Child>
          </div>

          <Transition.Child className={css.graphContainer}>
            <Transition.Child className={css.graph}></Transition.Child>
          </Transition.Child>
        </div>
      )}
    </Transition>
  );
};
